import {
  APIAdminOrganizationAttributes,
  APIPublicOrganizationAttributes,
  CustomDomain,
  Organization,
} from '@ardoq/api-types';

export const isAdminOrganizationAttributes = (
  organization: APIAdminOrganizationAttributes | APIPublicOrganizationAttributes
): organization is APIAdminOrganizationAttributes => {
  return (organization as APIAdminOrganizationAttributes).db !== undefined;
};

export const getCustomDomain = (
  organization: APIAdminOrganizationAttributes | Organization
): CustomDomain | null => organization['custom-domain'];

export const hasCustomDomain = (
  organization: APIAdminOrganizationAttributes | Organization
): boolean => getCustomDomain(organization) !== null;

export const hasInternalUserManagement = (
  organization: APIAdminOrganizationAttributes
): boolean => organization.ardoq['has-internal-user-management'] !== null;

export const getOrganizationByLabel = (
  organizations: APIAdminOrganizationAttributes[],
  label: string
): APIAdminOrganizationAttributes | null => {
  return (
    organizations.find(organization => organization.label === label) ?? null
  );
};

export const getOrganizationNameByLabel = (
  organizations: APIAdminOrganizationAttributes[],
  label: string
): string | null => {
  return getOrganizationByLabel(organizations, label)?.name ?? null;
};

export const getSettingByKey = <
  T extends keyof APIAdminOrganizationAttributes['settings'],
>(
  organization: { settings: APIAdminOrganizationAttributes['settings'] },
  key: T
): APIAdminOrganizationAttributes['settings'][T] | null => {
  return organization.settings[key] ?? null;
};
